// extracted by mini-css-extract-plugin
export default {"form":"Form_form__vs-Q7","inputContainer":"Form_inputContainer__jGdpm","input":"Form_input__vaw3o","errors":"Form_errors__h6K9z","submitbutton":"Form_submitbutton__lZ3Ux"};